import { createSlice } from '@reduxjs/toolkit'
import { PrefixType } from '../../interfaces/Prefix'
// types of order and orderBy are switched to any to not conflict with material-ui types
// typeof sortDirection = 'asc' | 'desc' | false and typeof direction = 'asc' | 'desc'
export const initialState = {
    order: '' as any,
    orderBy: '' as any,
}

const sortSlice = (prefix: PrefixType) =>
    createSlice({
        name: `${prefix}/sort`,
        initialState,
        reducers: {
            updateOrder: (state, action) => ({ ...state, order: action.payload }),
            updateOrderBy: (state, action) => ({ ...state, orderBy: action.payload }),
            resetSort: () => initialState,
        },
    })

const sort = (prefix: PrefixType) => sortSlice(prefix).reducer

export const sortActions = (prefix: PrefixType) => sortSlice(prefix).actions

export default sort
